import React from 'react';

import { Text } from '~/src/dash/components/text';
import { publicaColors } from '~/src/dash/utils/colors';

export const NewIcon = () => {
  return (
    <Text
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '20px',
        borderRadius: '3px',
        fontWeight: 500,
        fontSize: '12px',
        color: publicaColors.white,
        backgroundColor: publicaColors.red,
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)',
      }}
    >
      New
    </Text>
  );
};
